import request from '@/utils/request'

// 查询积分商品分页
export function fetchList(query) {
    return request({
        url: '/integral/prod/page',
        method: 'get',
        params: query,
    })
}
// 查询积分商品不分页
export function prodList(query) {
    return request({
        url: '/integral/prod/list',
        method: 'get',
        params: query,
    })
}
// 查询积分商品详细
export function getObj(id) {
    return request({
        url: '/integral/prod/detail?id=' + id,
        method: 'get',
    })
}
export function getObj2(id) {
    return request({
        url: '/taxation/prod/detail?prodId=' + id,
        method: 'get',
    })
}
// 新增积分商品
export function addObj(data) {
    return request({
        url: '/integral/prod/add',
        method: 'post',
        data: data,
    })
}

// 修改积分商品
export function putObj(data) {
    return request({
        url: '/integral/prod/edit',
        method: 'post',
        data: data,
    })
}
// 删除积分商品
export function delObj(data) {
    return request({
        url: '/integral/prod/delete',
        method: 'post',
        data: data,
    })
}
// 上下架积分商品
export function prodUnmount(data) {
    return request({
        url: '/integral/prod/unmount',
        method: 'post',
        data: data,
    })
}
// 增加库存
export function prodInventory(data) {
    return request({
        url: '/integral/prod/inventory',
        method: 'post',
        data: data,
    })
}
